








































































































































































import { PaginatedList } from "@/api/models/common/paginatedList";
import { OutilSuiviEnvTravail } from "@/api/models/outilsSuiviEnvTravail/outilSuiviEnvTravail";
import {
  BButton,
  BCard,
  BCol,
  BDropdown,
  BFormSelect,
  BDropdownItem,
  BFormInput,
  BPagination,
  BRow,
  BTable,
  BBadge,
  BSpinner
} from "bootstrap-vue";
import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import { errorAlert, successAlert } from "@/libs/sweetAlerts/alerts";
import { Entreprise } from "@/api/models/adherents/adherent";
import UpdateOutilSuiviEnvTravail from "./UpdateOutilSuiviEnvTravail.vue";
import CreateOutilSuiviEnvTravail from "./CreateOutilSuiviEnvTravail.vue";

@Component({
  components: {
    BCard,
    BRow,
    BCol,
    BButton,
    BFormInput,
    BTable,
    BPagination,
    BDropdown,
    BDropdownItem,
    BFormSelect,
    BBadge,
    BSpinner,
    CreateOutilSuiviEnvTravail,
    UpdateOutilSuiviEnvTravail, 
  },
})
export default class ListOutilsSuiviEnvTravail extends Vue {
  @Prop({ required: true }) adherent!: Entreprise;
  perPage = 10;
  currentPage = 1;
  perPageOptions = [2, 5, 10, 25, 50, 100];
  isAddNewOutilSuiviEnvTravailSidebarActive = false;
  isUpdateOutilSuiviEnvTravailSidebarActive = false;
  selectedOutilSuiviEnvTravailId = "";
  isSortDirDesc = false;
  sortBy = "nomFichier";

  tableColumns = [
    {key: 'nomFichier', sortable: true}, 
    {key: 'description', sortable: true}, 
    {key: 'dateDerniereModification', sortable: true}, 
    'actions'
  ];
  paginatedListOutilsSuiviEnvTravail = new PaginatedList<OutilSuiviEnvTravail>();
  loading = true;

  async created() {
    await this.loadListOutilsSuiviEnvTravail({
      pageNumber: this.currentPage,
      pageSize: this.perPage,
    });
  }

  get paginationFrom() {
    return (
      this.perPage * (this.currentPage - 1) +
      (this.paginatedListOutilsSuiviEnvTravail.items.length ? 1 : 0)
    );
  }
  get paginationTo() {
    return (
      this.perPage * (this.currentPage - 1) +
      this.paginatedListOutilsSuiviEnvTravail.items.length
    );
  }

  @Watch("currentPage")
  @Watch("perPage")
  async paginationChanged() {
    await this.loadListOutilsSuiviEnvTravail({
      pageNumber: this.currentPage,
      pageSize: this.perPage,
    });
  }

  selectOutilSuiviEnvTravail(outilSuiviEnvTravailId: string) {
    this.selectedOutilSuiviEnvTravailId = outilSuiviEnvTravailId;
    this.isUpdateOutilSuiviEnvTravailSidebarActive = true;
  }

  async downloadFile(adherentId: string, outilSuiviEnvTravailId: string) {
    await this.$http.myressif.entreprises
      .downloadOutilSuiviEnvTravail(adherentId, outilSuiviEnvTravailId)
      .then(
        async (response: any) => {
          window.open(response);
        },
        (error: any) => {
          if (error?.response?.data?.errors) {
            errorAlert.fire({
              text: error.response.data.errors[
                Object.keys(error.response.data.errors)[0]
              ],
            });
          } else {
            errorAlert.fire({
              text: error.message,
            });
          }
        }
      );
  }

  async loadListOutilsSuiviEnvTravail(params: any) {
    if (!params || params?.reset) {
      this.paginatedListOutilsSuiviEnvTravail = new PaginatedList<OutilSuiviEnvTravail>();
    }
    this.loading = true;
    await this.$http.myressif.entreprises
      .getListOutilsSuiviEnvTravailByEntrepriseId(
        this.$route.params.id,
        params?.pageNumber ?? 1,
        params?.pageSize ?? 10,
        params?.orderBy,
        params?.orderByDescending,
        params?.search ?? ""
      )
      .then((response: PaginatedList<OutilSuiviEnvTravail>) => {
        this.paginatedListOutilsSuiviEnvTravail = response;
      })
      .finally(() => {
        this.loading = false;
      });
  }

  updateSort(params: any) {
    this.sortBy = params.sortBy;

    params = {
      pageNumber: this.currentPage,
      pageSize: this.perPage,
      orderBy: this.sortBy,
      orderByDescending: this.isSortDirDesc
    };
    this.isSortDirDesc = !this.isSortDirDesc;
    this.loadListOutilsSuiviEnvTravail(params);
  }

  askDelete(id: string) {
    this.$bvModal
      .msgBoxConfirm("Etes-vous sûr de vouloir supprimer cet outil de suivi environnement de travail ?", {
        title: "Confirmation de suppression",
        size: "sm",
        okVariant: "primary",
        okTitle: "Oui",
        cancelTitle: "Non",
        cancelVariant: "outline-secondary",
        hideHeaderClose: false,
        centered: true,
      })
      .then(async (value) => {
        if (value === true) {
          await this.confirmDelete(id);
        } else {
          return;
        }
      });
  }

  async confirmDelete(id: string) {
    await this.$http.myressif.entreprises
      .deleteOutilSuiviEnvTravail(this.$route.params.id, id)
      .then(
        async (response: string) => {
          successAlert.fire({
            title: "Suppression d'un outil de suivi environnement de travail",
            text: "Suppression effectuée avec succès",
          });
        },
        (error: any) => {
          if (
            error?.response?.data?.errors &&
            Object.keys(error.response.data.errors).length
          ) {
            errorAlert.fire({
              text: error.response.data.errors[
                Object.keys(error.response.data.errors)[0]
              ],
            });
          } else {
            errorAlert.fire({
              text: error?.response?.data?.detail ?? error.message,
            });
          }
        }
      )
      .finally(() => {
        this.paginationChanged();
      });
  }
}
